import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, OnInit, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent } from "@angular/material/dialog";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { InfoCardComponent, InfoCardService } from "@tylertech/info-card-module";
import { IInfoCardData } from "@tylertech/tyler-api-types";

export interface ViewOnlyInfoCardDialogData
{
    readonly cardProviderId: string;
    readonly itemId: string;
}

// TODO - this shouldn't live here....
@Component({
    selector: "view-only-info-card-dialog-component",
    templateUrl: "./viewOnlyInfoCardDialog.tmpl.html",
    imports: [CdkScrollable, MatDialogContent, InfoCardComponent, MatDialogActions, LayoutDirective, LayoutAlignDirective, MatButton, MatDialogClose]
})
export class ViewOnlyInfoCardDialogComponent implements OnInit
{
    private readonly data = inject<ViewOnlyInfoCardDialogData>(MAT_DIALOG_DATA);
    private readonly $infoCardService = inject(InfoCardService);

    item: IInfoCardData;

    get cardProviderId(): string { return this.data.cardProviderId; }
    get itemId(): string { return this.data.itemId; }

    ngOnInit(): void
    {
        this.$infoCardService.Get({
            Id: this.itemId,
            CardProviderId: this.cardProviderId,
            Criteria: undefined,
        })
            .then(
                (item: IInfoCardData) =>
                {
                    this.item = item;
                },
                error =>
                {
                    console.error(error);
                });
    }
}
